import { CanActivate, Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { isUndefined } from 'util';
import { Globals } from '../globals/Globals';
import { RouterConst } from '../globals/RoutersConst';

@Injectable()
export class Authentication implements CanActivate {
  constructor(private cookiesService: CookieService, private router: Router) {}

  canActivate() {
    if (
      (isUndefined(Globals.TOKEN) || Globals.TOKEN.trim() === '') &&
      (isUndefined(this.cookiesService.get(Globals.COOKIES_TOKEN)) ||
        this.cookiesService.get(Globals.COOKIES_TOKEN).trim() === '')
    ) {
      this.router.navigate(['/' + RouterConst.LOGIN]);
    }
    return true;
  }
}

@Injectable()
export class Authentication4Login implements CanActivate {
  constructor(private cookiesService: CookieService, private router: Router) {}

  canActivate() {
    if (
      (isUndefined(Globals.TOKEN) || Globals.TOKEN.trim() === '') &&
      (isUndefined(this.cookiesService.get(Globals.COOKIES_TOKEN)) ||
        this.cookiesService.get(Globals.COOKIES_TOKEN).trim() === '')
    ) {
      return true;
    }
    this.router.navigate(['/' + RouterConst.MAIN]);
  }
}



// WEBPACK FOOTER //
// /home/sgurin/IdeaProjects/cosy/cp-builder/src/app/auth/Authentication.ts